import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from '../../api/auth';
import styles from './SessionExpiredModal.module.css';

const SessionExpiredModal = ({ isOpen=true, onClose, onLogin }) => {
  const [countdown, setCountdown] = useState(10);
  const navigate = useNavigate();
  const { execute: logout } = useLogout();

  const handleLogout = () => {
    logout({
      refreshToken: localStorage.getItem('refreshToken'),
    });

    if (onClose) onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.iconContainer}>
          <div className={styles.iconCircle}>
            <svg
              width="60"
              height="60"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ef4444"
              strokeWidth="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
        </div>

        <h2 className={styles.title}>Session Expired</h2>
        <p className={styles.message}>
          Your session has expired due to inactivity. Please log in again to continue.
        </p>

       
        <div className={styles.actions}>
          <button
            className={styles.btnSecondary}
            onClick={handleLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
